// =====================================================================
// commande-prete/surDalle.js — panneau « 🧱 Commandes sur dalle » (27-10-2026, demande Silviu)
// =====================================================================
// Calcul du serveur : GET /ready-orders/stats/dalle (droit « Administrer les commandes prêtes »).
// Fonctions PURES : testées par frontend/test/sur-dalle.test.mjs.
// =====================================================================

import { aujourdhuiBxl, bornes as bornesEncodage, decaler, auPlusTot } from './tempsEncodage.js';

export const PERIODES_DALLE = Object.freeze([
  { cle: '7j', libelle: '7 jours' },
  { cle: '30j', libelle: '30 jours' },
  { cle: 'tout', libelle: 'Depuis le 16/10' },
]);

/** { du, au } : 7 j / 30 j / depuis le début de la mesure (jamais avant le 16/10, 366 j au plus). */
export function bornesDalle(cle, maintenant = new Date()) {
  if (cle !== '30j') return bornesEncodage(cle, maintenant);
  const au = aujourdhuiBxl(maintenant);
  return { du: auPlusTot(decaler(au, -29)), au };
}

/** 40 min → « 40 min », 300 min → « 5 h », 1 500 min → « 1 j », 11 300 min → « 7,8 j », null → « — ». */
export function joursTexte(minutes) {
  if (minutes === null || minutes === undefined) return '—';
  const m = Math.max(0, Number(minutes) || 0);
  if (m < 60) return `${Math.floor(m)} min`;
  if (m < 1440) return `${Math.floor(m / 60)} h`;
  return `${String(Math.floor((m / 1440) * 10) / 10).replace('.', ',')} j`;   // même troncature que l'export (joursDecimaux)
}

/** Unités encore sur dalle d'une commande : « 2 / 4 pal. + 1 col. » (les colis comptent aussi : la commande n'est pas partie). */
export function texteRestant(l) {
  const col = l.colis ? ` + ${l.colisRestants ?? 0} / ${l.colis} col.` : '';
  return `${l.palettesRestantes} / ${l.palettes} pal.${col}`;
}

/** « 10 jours », « 1 jour », « moins de 24 h ». */
export function joursEntiers(n) {
  return n === 0 ? 'moins de 24 h' : `${n} jour${n > 1 ? 's' : ''}`;
}

// Couleur selon l'âge (mêmes tranches que le serveur) : vert → rouge foncé.
const COULEURS = [[1, '#16a34a'], [3, '#65a30d'], [7, '#d97706'], [14, '#dc2626'], [30, '#991b1b'], [Infinity, '#7f1d1d']];
export function couleurAge(minutes) {
  const j = (Number(minutes) || 0) / 1440;
  return COULEURS.find(([max]) => j < max)[1];
}
